// import { convertDateTimezone, databaseDate } from "@intrasync/utils";
import { databaseDate, getOffsetDate, parseDate } from "@intrasync/utils";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import React, { PureComponent } from "react";
import { PickersActionBarAction } from "@mui/x-date-pickers/PickersActionBar/PickersActionBar";
import { Button } from "components/Button";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

interface DatePickerProps {
  shouldDisableDate?: (date: Date) => boolean;
  renderDay?: (
    date: Date,
    selectedDate: Date,
    dayInCurrentMonth: boolean,
    dayComponent: JSX.Element
  ) => JSX.Element;
  autoOk?: boolean;
  okLabel?: string;
  inputProps?: object;
  clearable?: boolean;
  value: Date | string | null;
  onChange: (value: string) => void;
  enableLeftArrow?: boolean;
  enableRightArrow?: boolean;
  arrowsIgnoreWeekends?: boolean;
  label?: string;
  emptyLabel?: string;
  fullWidth?: boolean;
  showTodayButton?: boolean;
  showClearButton?: boolean;
  color?: string;
  dateFormat?: string;
  showLabel?: boolean;
  variant?: "outlined" | "filled" | "standard";
  views?: Array<"day" | "month" | "year">;
  readOnly?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  white?: boolean;
}

class DatePicker extends PureComponent<DatePickerProps> {
  static defaultProps = {
    views: ["day"],
    value: null,
    label: "Date",
    fullWidth: false,
    showTodayButton: true,
    showClearButton: false,
    emptyLabel: "No Date",
    dateFormat: "MM-dd-yy",
    showLabel: true,
    clearable: false,
    inputProps: {},
    okLabel: "OK",
    autoOk: false,
    renderDay: null,
    shouldDisableDate: null,
    readOnly: false,
    variant: "standard",
    disabled: false,
    autoFocus: false,
    white: false,
  };

  render() {
    const {
      value,
      onChange,
      label,
      fullWidth,
      showTodayButton,
      showClearButton,
      // emptyLabel,
      dateFormat,
      showLabel,
      // clearable,
      // inputProps,
      // okLabel,
      // autoOk,
      // renderDay,
      shouldDisableDate,
      variant,
      views,
      readOnly,
      disabled,
      autoFocus,
      white,
      enableLeftArrow,
      enableRightArrow,
      arrowsIgnoreWeekends,
    } = this.props;
    let dateValue = value;
    let showDateLabel = showLabel;
    let dateLabel = label;
    const actionBar = {
      actions: [
        ...(showClearButton ? ["clear"] : []),
        ...(showTodayButton ? ["today"] : []),
        "cancel" as const,
        "accept" as const,
      ] as PickersActionBarAction[],
    };

    if (!dateValue) {
      dateValue = null;
      showDateLabel = true;
      dateLabel =
        dateLabel !== "Date" ? `${dateLabel} - Not Set` : "Date Not Set";
    } else {
      dateValue = value ? parseDate(value as string) : null;
    }

    const divBackground = white
      ? { backgroundColor: "white", borderRadius: "6px" }
      : {};

    return (
      <div
        style={{
          paddingLeft: 5,
          paddingRight: 5,
          margin: 0,
          display: "flex",
          flexDirection: "row",
          ...divBackground,
        }}
      >
        {enableLeftArrow && (
          <Button
            size="small"
            color="transparent"
            justIcon
            tooltip="Previous Date"
            extraButtonSX={
              showDateLabel ? { margin: "10px 8px" } : { margin: "0px" }
            }
            onClick={() => {
              console.log("current date", value);
              let offset = -1;
              if (arrowsIgnoreWeekends) {
                const currentDate = parseDate(value as string);
                const day = currentDate.getDay();
                if (day === 0) {
                  offset = -2;
                } else if (day === 1) {
                  offset = -3;
                }
              }
              const dateBefore = getOffsetDate(value as string, {
                offset: offset,
              });
              console.log("dateBefore", dateBefore);
              onChange(dateBefore);
            }}
          >
            <ArrowBackIos />
          </Button>
        )}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MobileDatePicker
            autoFocus={autoFocus}
            views={views}
            format={dateFormat}
            value={dateValue instanceof Date ? dateValue : null}
            onChange={(value: Date | null) => {
              if (!value) return;
              onChange(databaseDate(value.toISOString()));
            }}
            label={showDateLabel ? dateLabel : null}
            // emptyLabel={emptyLabel}
            // clearable={clearable}
            // InputProps={inputProps}
            // okText={okLabel}
            // autoOk={autoOk}
            // renderDay={renderDay}
            shouldDisableDate={shouldDisableDate}
            // inputProps={{
            //   onKeyDown: (e: { preventDefault: () => void }) =>
            //     e.preventDefault(),
            // }}
            // showToolbar={false}
            readOnly={readOnly}
            disabled={disabled}
            slotProps={{
              textField: {
                variant: variant,
                fullWidth: fullWidth,
                sx: white
                  ? {
                      backgroundColor: "white",
                      borderRadius: "6px",
                      width: 80,
                    }
                  : undefined,
              },
              actionBar,
            }}
            onAccept={(value: Date | null) => {
              if (value === null) {
                onChange("1970-01-01");
                return;
              }

              onChange(databaseDate(value.toISOString()));
            }}
          />
        </LocalizationProvider>
        {enableRightArrow && (
          <Button
            size="small"
            color="transparent"
            justIcon
            tooltip="Next Date"
            extraButtonSX={
              showDateLabel ? { margin: "10px 8px" } : { margin: "0px" }
            }
            onClick={() => {
              console.log("current date", value);
              let offset = 1;
              if (arrowsIgnoreWeekends) {
                const currentDate = parseDate(value as string);
                console.log("current currentDate", currentDate);
                const day = currentDate.getDay();
                if (day === 6) {
                  offset = 2;
                } else if (day === 5) {
                  offset = 3;
                }
              }
              console.log("current offset", offset);
              const dateAfter = getOffsetDate(value as string, {
                offset: offset,
              });
              console.log("dateAfter", dateAfter);
              onChange(dateAfter);
            }}
          >
            <ArrowForwardIos />
          </Button>
        )}
      </div>
    );
  }
}

export default DatePicker;
